import React from 'react';
import { useTableFilteredBookings } from '../../state/bookings/bookingsFilterSlice';
import { BookingsTableToolbar } from './components/table/BookingsTableToolbar';
import Spinner from '@rio-cloud/rio-uikit/Spinner';
import classNames from 'classnames';
import { NoDataPlaceholder } from '../../components/NoDataPlaceholder';
import { BookingsTable } from './components/table/BookingsTable';
import { FleetMonitorLink } from './components/table/FleetMonitorLink';

export const BookingsPage: React.FC = () => {
  const {
    filteredBookings: bookings,
    isLoading,
    error,
  } = useTableFilteredBookings();

  const showTwoColumns = bookings.length > 5;

  return (
    <div>
      <BookingsTableToolbar />
      <div className="row height-100pct">
        {isLoading ? (
          <Spinner isDoubleSized />
        ) : (
          <div
            className={classNames(
              showTwoColumns
                ? 'col-8 height-100pct'
                : 'col-12 margin-bottom-25',
              'display-flex',
              'flex-column',
            )}
          >
            {error ? <NoDataPlaceholder /> : <BookingsTable />}
          </div>
        )}
        <div
          className={classNames(
            showTwoColumns
              ? 'col-4 position-sticky top-0'
              : 'col-12 max-height-250',
          )}
        >
          <div
            className={classNames({
              'max-height-250': !showTwoColumns,
            })}
          >
            <FleetMonitorLink horizontal={!showTwoColumns} />
          </div>
        </div>
      </div>
    </div>
  );
};
